import React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import {BreadcrumbsBlock as Breadcrumbs} from "@arctheme-components/blocks/BreadcrumbsBlock/Breadcrumbs";
import ActionBar from "@arctheme-components/blocks/ActionBar/ActionBar";
import { Button } from "@arctheme-components/elements/Button/Button";

const TwoColumnLayout = ({ blocks, settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const isAccountPage = window?.location?.pathname?.split("/")[1] === "account";
  const { customer_name } = settings?.globals

  const renderBlock = (block, index) => {
    const commonClasses = `
      text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop}
      pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]
      pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px]
      px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]
    `;

    switch (block.type) {
      case "description":

        const textStyle = isMobile
          ? block.settings.text_style_mobile
          : block.settings.text_style;

        return (
          <div
            key={`description_${index}_column_${block.settings.column}`}
            className={`${textStyle} text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <Paragraph
              text={block.settings.text}
              type={textStyle}
              maxChars={block.settings.truncate_text ? 250 : 9999}
            />
          </div>
        );
      case "title":
        return (
          <div
            key={`title_${index}_column_${block.settings.column}`}
            className={`
              flex h-full items-center
              
              justify-${block.settings.content_alignment_mobile}
              lg:justify-${block.settings.content_alignment_desktop}
              
              pt-[${block.settings.padding_top_mobile}px]
              lg:pt-[${block.settings.padding_top_desktop}px]
              
              pb-[${block.settings.padding_bottom_mobile}px] 
              lg:pb-[${block.settings.padding_bottom_desktop}px]
              
              px-[${block.settings.padding_left_right_mobile}px]
              lg:px-[${block.settings.padding_left_right_desktop}px]
            `}
          >
            <div className="flex flex-col gap-2">
              <h1 className={`hidden lg:block ${block.settings.heading_type}`}>
                {block.settings.title}
              </h1>

              <h1 className={`lg:hidden block ${block.settings.heading_type_mobile}`}>
                {block.settings.title}
              </h1>

              {(isAccountPage && customer_name && !isMobile) && (
                <p className='b2'>
                  Welcome back {customer_name}!
                </p>
              )}
            </div>
          </div>
        );
      case "tagline":
        return (
          <div
            key={`tagline_${index}_column_${block.settings.column}`}
            className={`text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <Paragraph
              text={block.settings.text}
              type={`${isMobile ? block.settings.heading_type_mobile : block.settings.heading_type}`}
            />
          </div>
        );
      case "breadcrumbs":
        return (
          <div
            key={`breadcrumbs_${index}_column_${block.settings.column}`}
            className={`text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <Breadcrumbs
              templateName={"page"}
              shop={settings.shop}
              page={settings.page}
              request={settings.request}
            />
          </div>
        );
      case "sociallinks":
        return (
          <div
            key={`sociallinks_${index}_column_${block.settings.column}`}
            className={`pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <ActionBar
              label={block.settings.action_text}
              altLinks={{
                x_url: block.settings.x_url,
                facebook_url: block.settings.facebook_url,
                instagram_url: block.settings.instagram_url,
                linkedin_url: block.settings.linkedin_url,
              }}
            />
          </div>
        );
      case "button":
        return (
          <div
            key={`button_${index}_column_${block.settings.column}`}
            className={`text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <a href="#" className={`${block.settings.button_type}`}>
              {block.settings.text}
            </a>
          </div>
        );
      case "actions":
        return (
          <div
            key={`actions_${index}_column_${block.settings.column}`}
            className={`text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <div className={"actions__container flex items-center gap-x-[8px]"}>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-phone-call text-[20px]`}></i>{" "}
                <a href={`tel:${block.settings.phone}`}>Call Us</a>
              </div>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-mail-send text-[20px]`}></i>{" "}
                <a href={`mailto:${block.settings.email}`}>Email</a>
              </div>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-face text-[20px]`}></i>{" "}
                <a href={`${block.settings.chat}`}>Live Chat</a>
              </div>
            </div>
          </div>
        );
      case "image":
        const imageUrl = isMobile
          ? block.settings.image_mobile
          : block.settings.image;
        return (
          <img
            key={`image_${index}_column_${block.settings.column}`}
            className="absolute left-0 object-contain h-full w-full"
            style={{ top: isMobile ? block.settings.mobile_offset : block.settings.desktop_offset }}
            src={imageUrl}
            alt=""
          />
        );
      case "url":
        return (
          <div
            key={`url_${index}_column_${block.settings.column}`}
            className={`url-block text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop} pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px] pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px] px-[${block.settings.padding_left_right_mobile}px] lg:px-[${block.settings.padding_left_right_desktop}px]`}
          >
            <Button
              reverse
              buttonStyle={{}}
              style="text"
              text
              label={block.settings.text}
              link={block.settings.url}
              icon="ur-arrow"
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className={`two-column flex h-[${settings.section.header_height}px] overflow-hidden`}>
      <div
        className={`left-panel relative flex basis-[50%] flex-col color-${settings.section.color_schema}`}
        style={{
          backgroundImage: `url(${settings.section.text_content_background_image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          justifyContent: settings.section.vertical_alignment
        }}
      >
        {blocks.filter((block) => block.settings.column === 1).map(renderBlock)}
      </div>
      <div
        className={`left-panel relative flex basis-[50%] flex-col justify-center color-${settings.section.color_schema}`}
      >
        {blocks.filter((block) => block.settings.column === 2).map(renderBlock)}
      </div>
    </div>
  );
};

export default TwoColumnLayout;
